export enum SourceOfRecordsMovementType {
    TheatreMovements = 'TheatreMovements',
    TheatreMaterials = 'TheatreMaterials',
    TheatreServices = 'TheatreServices',
    TheatreVisit = 'TheatreVisit',
    HospitalMovements = 'HospitalMovements',
    Basket = 'Basket',
    Credit = 'Credit'
}